module.exports = __webpack_public_path__ + "static/media/add_circle_light.21c41802.svg";